import app from 'new-ui/app';

/**
 * Evaluates if an action's conditions are met.
 * @param {object} conditions - The conditions object from the action.
 * @param {object} context - The evaluation context.
 * @returns {boolean} True if all conditions are met, false otherwise.
 */
export const evaluateActionConditions = (conditions, context) => {
  if (!conditions || Object.keys(conditions).length === 0) {
    return true;
  }

  for (const key in conditions) {
    if (Object.prototype.hasOwnProperty.call(conditions, key)) {
      const conditionValue = conditions[key];
      let conditionMet = false;
      switch (key) {
        case 'have_biomarker':
          conditionMet = (context.have_biomarker === conditionValue);
          break;
        case 'selected_standard_only':
          conditionMet = (context.selected_standard_only === conditionValue);
          break;
        case 'selected_trial':
          conditionMet = (context.selected_trial === conditionValue);
          break;
        case 'trial_within_100_miles':
          conditionMet = (context.trial_within_100_miles === conditionValue);
          break;
        case 'has_location':
          conditionMet = (context.has_location === conditionValue);
          break;
        case 'has_targeted_trials':
          conditionMet = (context.has_targeted_trials === conditionValue);
          break;
        case 'has_missing_critical_info':
          conditionMet = (context.has_missing_critical_info === conditionValue);
          break;
        case 'has_phase_3_trials':
          conditionMet = (context.has_phase_3_trials === conditionValue);
          break;
        case 'sponsored':
          if (conditionValue === true) {
            const hasSponsorCount = app?.matchesResult?.sponsor_trials_count > 0;
            const localAppTrials = app.trials || [];
            const hasSponsorNameInTrials = localAppTrials.some(
              (trial) => trial && typeof trial.sponsorName === 'string' && trial.sponsorName.trim() !== '',
            );
            conditionMet = hasSponsorCount || hasSponsorNameInTrials;
          }
          break;
        case 'urlMatch':
          if (typeof conditionValue === 'string' && conditionValue.length > 0) {
            const currentUrl = window.location.pathname + window.location.search;
            conditionMet = currentUrl.includes(conditionValue);
          }
          break;
        default:
          console.warn(`Unknown condition key in NBA action: "${key}"`);
          conditionMet = false;
          break;
      }

      if (!conditionMet) {
        return false;
      }
    }
  }

  return true;
};
